import React, { useState, useRef } from "react";
import { Button, Spinner, Card, Row, Col, Table } from "react-bootstrap";
import Layout from "../../layout/Layout";
import { customerApi } from "../../../utils/apiConfig";
import Select from "react-select";
import Accordion from "react-bootstrap/Accordion";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

import html2canvas from "html2canvas";
import ChartDataLabels from "chartjs-plugin-datalabels";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
ChartJS.register(ArcElement, Tooltip, Legend);
ChartJS.register(ChartDataLabels);

export default function SevkRapor() {
  const musteriRef = useRef(null);

  const [file, setFile] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [initialFilters, setInitialFilters] = useState(null);


  const [filters, setFilters] = useState({
    kalinlikCins: ["(Tümü)"],
    kalinlikStokAdi: ["(Tümü)"],
    kalinlikTur: ["(Tümü)"],
    kalinlikEbat: ["(Tümü)"],
    kalinlikMin: "",
    kalinlikMax: "",
    ebatCins: ["(Tümü)"],
    ebatStokAdi: ["(Tümü)"],
    ebatTur: ["(Tümü)"],
    ebatKalinlik: ["(Tümü)"],
    cariCins: ["(Tümü)"],
    cariStokAdi: ["(Tümü)"],
    cariTur: ["(Tümü)"],
  });
  const handleMultiSelect = (items) => {
    if (!items || items.length === 0) return ["(Tümü)"];

    const values = items.map((x) => x.value);

    // Eğer başka seçim varsa → (Tümü)'yü kaldır
    if (values.includes("(Tümü)") && values.length > 1) {
      return values.filter((v) => v !== "(Tümü)");
    }

    return values;
  };

  const handleDownloadExcel = async () => {
    if (!data?.analizler?.musteriDurum) return;

    const analiz = data.analizler.musteriDurum;

    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet("Müşteri Durum");

    // ===========================
    // 1) TABLO BAŞLIKLARI
    // ===========================
    const yilListesi = analiz.yilListesi || [];
    const headerRow = ["Cari Ünvanı", ...yilListesi.map(String), "Durum"];
    ws.addRow(headerRow);

    ws.getRow(1).font = { bold: true };
    ws.getRow(1).alignment = { horizontal: "center" };
    ws.columns = headerRow.map(() => ({ width: 22 }));

    // ===========================
    // 2) TABLO SATIRLARI
    // ===========================
    const rows = analiz.tablo || [];

    rows.forEach((item) => {
      const row = [
        item["Cari Ünvanı"],
        ...yilListesi.map((y) => item[y] || 0),
        item.durum,
      ];
      ws.addRow(row);
    });

    // ===========================
    // 3) SUMMARY (Alt Bilgi Tablosu)
    // ===========================
    ws.addRow([]);
    ws.addRow(["Özet Bilgiler"]);
    ws.getRow(ws.lastRow.number).font = { bold: true };

    ws.addRow(["Durum", "Adet", "Yüzde"]);

    const summary = analiz.summary || [];
    const total = summary.reduce((a, b) => a + b.value, 0);

    summary.forEach((item) => {
      const pct = total ? ((item.value / total) * 100).toFixed(1) : "0.0";
      ws.addRow([item.type, item.value, pct + " %"]);
    });

    // ======================================================
    // 4) GRAFİĞİ PNG OLARAK AL → EXCEL'E EKLE
    // ======================================================
    const chartCanvas = await html2canvas(
      musteriRef.current.querySelector("#pdf-chart-area"),
      { scale: 2, useCORS: true }
    );

    const chartImg = chartCanvas.toDataURL("image/png");

    const chartImageId = wb.addImage({
      base64: chartImg,
      extension: "png",
    });

    // Grafik için başlangıç satırı (tablo + summary bitti)
    const startRow = ws.lastRow.number + 2;

    ws.addImage(chartImageId, {
      tl: { col: 0, row: startRow },
      ext: {
        width: chartCanvas.width * 0.3,
        height: chartCanvas.height * 0.3,
      },
    });

    // ===========================
    // 5) DOSYAYI İNDİR
    // ===========================
    const buf = await wb.xlsx.writeBuffer();
    saveAs(new Blob([buf]), "musteri_durum.xlsx");
  };

  // --------------------------------------------------
  // 1) EXCEL UPLOAD → secondSevkRapor
  // --------------------------------------------------
  const uploadExcel = async () => {
    const fd = new FormData();
    fd.append("excelFile", file);

    const { data } = await customerApi.post("/secondSevkRapor", fd, {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
    });

    return data.fileKey;
  };

  // --------------------------------------------------
  // 2) fileKey → sevkRapor (TAM ANALİZ)
  // --------------------------------------------------
  const getAnaliz = async (fileKey) => {
    const body = {
      fileKey,
      kalinlikCins: "(Tümü)",
      kalinlikStokAdi: "(Tümü)",
      kalinlikTur: "(Tümü)",
      kalinlikEbat: "(Tümü)",
      cariCins: "(Tümü)",
      cariTur: "(Tümü)",
      cariStokAdi: "(Tümü)",
      ebatCins: "(Tümü)",
      ebatStokAdi: "(Tümü)",
      ebatTur: "(Tümü)",
      ebatKalinlik: "(Tümü)",
      startDate: startDate || null,
      endDate: endDate || null,
    };

    const { data } = await customerApi.post("/sevkRapor", body, {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
    });

    return data; // full { success, years, analizler, ... }
  };

  // --------------------------------------------------
  // Upload & Analiz Trigger
  // --------------------------------------------------
  const handleProcess = async (e) => {
    e.preventDefault();
    if (!file) return alert("Excel dosyası seçmelisin!");

    try {
      setLoading(true);
      const fileKey = await uploadExcel();
      const analiz = await getAnaliz(fileKey);

      if (!initialFilters) {
        setInitialFilters({
          profil: analiz.analizler.profilKalinlikSevkTonaj.filterParameters,
          ebat: analiz.analizler.ebatGruplamaSevkKg.filterParameters,
          cari: analiz.analizler.cariSevkTonaj.filterParameters,
        });
      }

      setData(analiz);
    } catch (err) {
      console.error(err);
      alert("Hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // Genel Sevk Parser
  // ============================================================
  const parseGenelSevk = (genel, year) => {
    if (!genel?.byYear?.[year]) return [];

    const yearData = genel.byYear[year];
    const rows = [];

    const fmtLocal = (v) =>
      new Intl.NumberFormat("tr-TR").format(Number(v || 0));
    const pct = (v) =>
      Number(v || 0)
        .toFixed(2)
        .replace(".", ",") + " %";

    Object.entries(yearData).forEach(([tur, turData]) => {
      let grupRows = [];
      let grupToplam = null;

      if (tur === "Genel Toplam") {
        rows.push({
          special: "GENEL_TOPLAM",
          tur: "Genel Toplam",
          stokAdi: "",
          yilKg: fmtLocal(turData[year]),
          yilPct: pct(turData[`${year}_yuzde`]),
          toplam: fmtLocal(turData.toplam),
          toplamPct: pct(turData.toplam_yuzde),
        });
        return;
      }

      if (typeof turData[year] === "number") {
        rows.push({
          tur,
          stokAdi: "",
          yilKg: fmtLocal(turData[year]),
          yilPct: pct(turData[`${year}_yuzde`]),
          toplam: fmtLocal(turData.toplam),
          toplamPct: pct(turData.toplam_yuzde),
        });
        return;
      }

      Object.entries(turData).forEach(([stokAdi, stok]) => {
        if (stokAdi === "_toplam") {
          grupToplam = stok.type_total;
          return;
        }

        grupRows.push({
          tur,
          stokAdi,
          yilKg: fmtLocal(stok[year]),
          yilPct: pct(stok[`${year}_yuzde`]),
          toplam: fmtLocal(stok.toplam),
          toplamPct: pct(stok.toplam_yuzde),
        });
      });

      if (grupToplam) {
        grupRows.push({
          special: "GRUP_TOPLAM",
          tur,
          stokAdi: "Grup Toplamı",
          yilKg: fmtLocal(grupToplam[year]),
          yilPct: pct(grupToplam[`${year}_yuzde`]),
          toplam: fmtLocal(grupToplam.toplam),
          toplamPct: pct(grupToplam.toplam_yuzde),
        });
      }

      rows.push(...grupRows);
    });

    return rows;
  };

  // ============================================================
  // YEARS & FMT
  // ============================================================
  const years = data?.years ?? [];
  const activeYear = years[0] ?? new Date().getFullYear();
  const fmt = (v) => new Intl.NumberFormat("tr-TR").format(v || 0);
  const DIS_TICARET_LIST = [
    "ZND UK LTD.",
    "VEKO POWER Bulgaria Ltd",
    "VEKO POWER BULGARİA LTD",
    "GOKTAS FLAT STEEL PRODUCTS INDUSTRY TRADİNG SRL",
    "RAMSTEEL TUBES LTD",
    "ISCO ÇELİK AYAKKABI TEKSTİL MAMULLERİ SAN.VE TİC.LTD.ŞTİ.",
    "JOMAR ENTERPRISE",
    "ETS Bah IBRAHIMA et FRERES",
    "IOANNIDIS TH S.A",
    "GOKTAS FLAT STEEL PRODUCTS INDUSTRY TRADING S.R.L. -( EUR )",
    "ZND US EAST",
    "Betafence Deutschland GmbH",
    "Ets Sounounou Bah et Fils",
    "MEHMET SUNGURI B.I.",
    "Securafence Manufacturing Ltd",
    "ZND US West Inc",
    "GOKTAS IBERIA SL",
    "S.C. RIPEN S.R.L",
    "SOCOTRI SARL",
    "BATISEC ORLEANS",
    "KOÇAK ÇELİK LİMİTED ŞİRKETİ",
    "TRIBULO LTD",
    "ELITA GROUP SH.P.K",
    "GLOBAL SOURCING NETWORK",
    "UNIVERS DU METAL SARL",
    "LANTABOORA ASSET MANAGEMENT LTD.",
    "RIPEN SRL",
    "ETS HORİZON METAL",
    "MANUCHAR STEEL NV",
    "MANTZOROS SA",
    "TPF EUROPA BV",
    "CHAFRA TUBES",
    "STE MBG",
    "ELITA O.P.",
    "GROWFAST LTD.",
  ];

  // 🔒 NORMALIZE EDİLMİŞ SET
  const DIS_TICARET_SET = new Set(
    DIS_TICARET_LIST.map((x) => x.trim().toUpperCase())
  );

  // 🔒 TEK VE ORTAK FONKSİYON
  const ticaretTipi = (cari) => {
    const key = String(cari || "")
      .trim()
      .toUpperCase();
    return DIS_TICARET_SET.has(key) ? "Dış Ticaret" : "İç Ticaret";
  };

  const [ticaretFilter, setTicaretFilter] = React.useState("Tümü");
  const [durumFilter, setDurumFilter] = React.useState("Tümü");

  function MusteriDurumTable({ analiz, ticaretFilter, durumFilter }) {
    const [sort, setSort] = React.useState({
      column: null,
      direction: 1,
    });

    const handleSort = (column) => {
      setSort((prev) => {
        if (prev.column === column) {
          return { column, direction: prev.direction * -1 };
        }
        return { column, direction: 1 };
      });
    };

    const sortIcon = (column) => {
      if (sort.column !== column) return "↕";
      return sort.direction === 1 ? "▲" : "▼";
    };

    const yilListesi = analiz.yilListesi ?? [];
    const tablo = React.useMemo(() => analiz.tablo ?? [], [analiz.tablo]);

    const fmt = (v) => new Intl.NumberFormat("tr-TR").format(Number(v || 0));

    // === DURUM RENKLERİ ===
    const durumRenk = (d) => {
      if (d === "Kaybedilen Müşteri") return "#ffe5e5";
      if (d === "Yeni Müşteri") return "#e5ffe5";
      if (d === "Devam Eden Müşteri") return "#e5f0ff";
      return "#f7f7f7";
    };

    const filteredRows = React.useMemo(() => {
      return tablo.filter((r) => {
        const ticaretOK =
          ticaretFilter === "Tümü" ||
          ticaretTipi(r["Cari Ünvanı"]) === ticaretFilter;

        const durumOK = durumFilter === "Tümü" || r.durum === durumFilter;

        return ticaretOK && durumOK;
      });
    }, [tablo, ticaretFilter, durumFilter]);

    const sortedRows = React.useMemo(() => {
      if (!sort.column) return filteredRows;

      return [...filteredRows].sort((a, b) => {
        const aVal = a[sort.column];
        const bVal = b[sort.column];

        if (!isNaN(aVal) && !isNaN(bVal)) {
          return (aVal - bVal) * sort.direction;
        }

        return (
          String(aVal || "").localeCompare(String(bVal || ""), "tr") *
          sort.direction
        );
      });
    }, [filteredRows, sort.column, sort.direction]);

    return (
      <Table bordered hover responsive>
        <thead className="table-light">
          <tr>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("Cari Ünvanı")}
            >
              Cari Ünvanı {sortIcon("Cari Ünvanı")}
            </th>
            {yilListesi.map((y) => (
              <th
                key={y}
                style={{ cursor: "pointer", textAlign: "right" }}
                onClick={() => handleSort(y)}
              >
                {y} (Kg) {sortIcon(y)}
              </th>
            ))}

            <th
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("durum")}
            >
              Durum {sortIcon("durum")}
            </th>
          </tr>
        </thead>

        <tbody>
          {sortedRows.map((row, i) => (
            <tr key={i}>
              <td>{row["Cari Ünvanı"]}</td>

              {yilListesi.map((y) => (
                <td key={y} className="text-end">
                  {fmt(row[y])}
                </td>
              ))}

              <td
                style={{ backgroundColor: durumRenk(row.durum) }}
                className="fw-bold"
              >
                {row.durum}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }

  return (
    <Layout>
      <div className="container mt-4">
        <h3 className="mb-4">Sevk Rapor Analiz</h3>

        {/* -------------------------------------------------- */}
        {/* Upload Form */}
        {/* -------------------------------------------------- */}
        <form onSubmit={handleProcess} className="mb-4">
          <Row className="alin-items-center">
            <Col md={6}>
              <input
                type="file"
                className="form-control"
                accept=".xlsx,.xls"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </Col>

            <Col sm={4} md={3} xl={2}>
              <label className="form-label">Başlangıç</label>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Col>

            <Col sm={4} md={3} xl={2}>
              <label className="form-label">Bitiş</label>
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Col>

            <Col md={6} className="text-end mt-3">
              <Button type="submit" variant="primary">
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Excel Yükle"
                )}
              </Button>
            </Col>
          </Row>
        </form>

        {/* ======================================================
            GENEL SEVK DURUMU TABLOSU
        ======================================================= */}
        <Accordion defaultActiveKey={null} alwaysOpen={false}>
          {data?.analizler?.genelSevkDurumu && (
            <Accordion.Item eventKey="genel">
              <Accordion.Header>Genel Sevk Durumu</Accordion.Header>
              <Accordion.Body>
                <Card className="p-3 mb-4">
                  <h5>Genel Sevk Durumu</h5>

                  <Table bordered hover responsive className="mt-3">
                    <thead className="table-light">
                      <tr>
                        <th>TÜR</th>
                        <th>Stok Adı</th>
                        <th>{activeYear} (Kg)</th>
                        <th>{activeYear} (%)</th>
                        <th>Toplam</th>
                        <th>Toplam (%)</th>
                      </tr>
                    </thead>

                    <tbody>
                      {(() => {
                        let prevTur = null;

                        return parseGenelSevk(
                          data.analizler.genelSevkDurumu,
                          activeYear
                        ).map((row, i) => {
                          const isTurChanged = row.tur !== prevTur;
                          prevTur = row.tur;

                          return (
                            <React.Fragment key={i}>
                              {isTurChanged && i !== 0 && (
                                <tr>
                                  <td
                                    colSpan={6}
                                    style={{
                                      height: "10px",
                                      background: "#f7f7f7",
                                      borderTop: "3px solid #d0d0d0",
                                    }}
                                  ></td>
                                </tr>
                              )}

                              <tr
                                style={{
                                  fontWeight:
                                    row.special === "GRUP_TOPLAM" ||
                                    row.special === "GENEL_TOPLAM"
                                      ? "bold"
                                      : "normal",
                                  background:
                                    row.special === "GENEL_TOPLAM"
                                      ? "#fffbe6"
                                      : row.special === "GRUP_TOPLAM"
                                      ? "#f3f3f3"
                                      : "white",
                                }}
                              >
                                <td>{row.tur}</td>
                                <td>{row.stokAdi}</td>
                                <td>{row.yilKg}</td>
                                <td>{row.yilPct}</td>
                                <td>{row.toplam}</td>
                                <td>{row.toplamPct}</td>
                              </tr>
                            </React.Fragment>
                          );
                        });
                      })()}
                    </tbody>
                  </Table>
                </Card>
              </Accordion.Body>
            </Accordion.Item>
          )}

          {/* ======================================================
          PROFİL KALINLIK BAZINDA SEVK TONAJI --- FİLTRE + TABLO
        ======================================================= */}
          {data?.analizler?.profilKalinlikSevkTonaj && (
            <Accordion.Item eventKey="profil">
              <Accordion.Header>
                Profil – Kalınlık Bazında Sevk Tonajı
              </Accordion.Header>
              <Accordion.Body>
                <Card className="p-3 mb-4">
                  <h5>Profil Kalınlık Bazında Sevk Tonajı</h5>

                  {/* ---------- FİLTRELER ---------- */}
                  <Row className="mb-3">
                    {/* kalinlikCins */}
                    <Col md={3}>
                      <label className="form-label">Cins</label>
                      <Select
                        isMulti
                        options={
                          initialFilters?.profil?.Cins?.map((v) => ({
                            label: v,
                            value: v,
                          })) ?? []
                        }
                        value={filters.kalinlikCins.map((v) => ({
                          label: v,
                          value: v,
                        }))}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            kalinlikCins: handleMultiSelect(e),
                          })
                        }
                      />
                    </Col>

                    {/* kalinlikStokAdi */}
                    <Col md={3}>
                      <label className="form-label">Stok Adı</label>
                      <Select
                        isMulti
                        options={
                          initialFilters?.profil?.["Stok Adı"]?.map((v) => ({
                            label: v,
                            value: v,
                          })) ?? []
                        }
                        value={filters.kalinlikStokAdi.map((v) => ({
                          label: v,
                          value: v,
                        }))}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            kalinlikStokAdi: handleMultiSelect(e),
                          })
                        }
                      />
                    </Col>

                    {/* kalinlikTur */}
                    <Col md={3}>
                      <label className="form-label">Tür</label>
                      <Select
                        isMulti
                        options={
                          initialFilters?.profil?.TÜR?.map((v) => ({
                            label: v,
                            value: v,
                          })) ?? []
                        }
                        value={filters.kalinlikTur.map((v) => ({
                          label: v,
                          value: v,
                        }))}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            kalinlikTur: handleMultiSelect(e),
                          })
                        }
                      />
                    </Col>

                    {/* kalinlikEbat */}
                    <Col md={3}>
                      <label className="form-label">Ebat</label>
                      <Select
                        isMulti
                        options={
                          initialFilters?.profil?.EBAT?.map((v) => ({
                            label: v,
                            value: v,
                          })) ?? []
                        }
                        value={filters.kalinlikEbat.map((v) => ({
                          label: v,
                          value: v,
                        }))}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            kalinlikEbat: handleMultiSelect(e),
                          })
                        }
                      />
                    </Col>
                  </Row>

                  {/* Kalınlık Min - Max */}
                  <Row className="mb-3">
                    <Col md={3}>
                      <label className="form-label">Kalınlık (Min)</label>
                      <input
                        type="number"
                        className="form-control"
                        value={filters.kalinlikMin}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            kalinlikMin: e.target.value,
                          })
                        }
                      />
                    </Col>

                    <Col md={3}>
                      <label className="form-label">Kalınlık (Max)</label>
                      <input
                        type="number"
                        className="form-control"
                        value={filters.kalinlikMax}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            kalinlikMax: e.target.value,
                          })
                        }
                      />
                    </Col>

                    <Col md={3} className="d-flex align-items-end">
                      <Button
                        className="w-100"
                        onClick={async () => {
                          const body = {
                            fileKey: data.fileKey,

                            kalinlikCins: filters.kalinlikCins,
                            kalinlikStokAdi: filters.kalinlikStokAdi,
                            kalinlikTur: filters.kalinlikTur,
                            kalinlikEbat: filters.kalinlikEbat,

                            kalinlikMin: filters.kalinlikMin || null,
                            kalinlikMax: filters.kalinlikMax || null,

                            // diğer analizleri bozma
                            cariCins: "(Tümü)",
                            cariTur: "(Tümü)",
                            cariStokAdi: "(Tümü)",
                            ebatCins: "(Tümü)",
                            ebatStokAdi: "(Tümü)",
                            ebatTur: "(Tümü)",
                            ebatKalinlik: "(Tümü)",

                            startDate:
                              data.appliedDateFilter?.startDate ?? null,
                            endDate: data.appliedDateFilter?.endDate ?? null,
                          };

                          const res = await customerApi.post(
                            "/sevkRapor",
                            body,
                            {
                              headers: {
                                Authorization: `Bearer ${sessionStorage.getItem(
                                  "token"
                                )}`,
                              },
                            }
                          );

                          const yeni =
                            res.data.analizler.profilKalinlikSevkTonaj;

                          // Sadece bu analizi güncelle, diğerleri sabit kalsın
                          setData((prev) => ({
                            ...prev,
                            analizler: {
                              ...prev.analizler,
                              profilKalinlikSevkTonaj: yeni,
                            },
                          }));
                        }}
                      >
                        Filtrele
                      </Button>
                    </Col>
                  </Row>

                  {/* ---------- TABLO ---------- */}
                  {(() => {
                    const analiz = data.analizler.profilKalinlikSevkTonaj;

                    const yilObj = analiz.byYear?.[activeYear] ?? {};
                    const detay = yilObj.detay ?? {};
                    const toplam = yilObj.toplam ?? 0;

                    const rows = Object.entries(detay)
                      .map(([kalinlik, kg]) => ({
                        kalinlik,
                        kg: Number(kg),
                        pct: toplam ? (kg / toplam) * 100 : 0,
                      }))
                      .sort((a, b) => Number(a.kalinlik) - Number(b.kalinlik));

                    return (
                      <Table bordered hover responsive className="mt-3">
                        <thead className="table-light">
                          <tr>
                            <th>KALINLIK</th>
                            <th>{activeYear} (Kg)</th>
                            <th>{activeYear} (%)</th>
                            <th>Toplam (Kg)</th>
                            <th>Toplam (%)</th>
                          </tr>
                        </thead>

                        <tbody>
                          {rows.map((row, i) => (
                            <tr key={i}>
                              <td>{row.kalinlik}</td>
                              <td>{fmt(row.kg)}</td>
                              <td>{row.pct.toFixed(2).replace(".", ",")} %</td>
                              <td>{fmt(row.kg)}</td>
                              <td>{row.pct.toFixed(2).replace(".", ",")} %</td>
                            </tr>
                          ))}

                          <tr
                            style={{
                              background: "#fffce6",
                              fontWeight: "bold",
                              borderTop: "3px solid #000",
                            }}
                          >
                            <td>Genel Toplam</td>
                            <td>{fmt(toplam)}</td>
                            <td>100 %</td>
                            <td>{fmt(toplam)}</td>
                            <td>100 %</td>
                          </tr>
                        </tbody>
                      </Table>
                    );
                  })()}
                </Card>
              </Accordion.Body>
            </Accordion.Item>
          )}

          {/* ======================================================
                EBAT GRUPLAMA SEVK KG --- FİLTRELER
            ====================================================== */}
          {data?.analizler?.ebatGruplamaSevkKg && (
            <Accordion.Item eventKey="ebat">
              <Accordion.Header>Ebat Bazında Sevk Tonajı</Accordion.Header>
              <Accordion.Body>
                <Card className="p-3 mb-4">
                  <h5>Ebat Bazında Sevk Tonajı</h5>

                  <Row className="mb-3">
                    {/* ebatCins */}
                    <Col md={3}>
                      <label className="form-label">Cins</label>
                      <Select
                        isMulti
                        options={
                          initialFilters?.ebat?.Cins?.map((v) => ({
                            label: v,
                            value: v,
                          })) ?? []
                        }
                        value={filters.ebatCins.map((v) => ({
                          label: v,
                          value: v,
                        }))}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            ebatCins: handleMultiSelect(e),
                          })
                        }
                      />
                    </Col>

                    {/* ebatStokAdi */}
                    <Col md={3}>
                      <label className="form-label">Stok Adı</label>
                      <Select
                        isMulti
                        options={
                          initialFilters?.ebat?.["Stok Adı"]?.map((v) => ({
                            label: v,
                            value: v,
                          })) ?? []
                        }
                        value={filters.ebatStokAdi.map((v) => ({
                          label: v,
                          value: v,
                        }))}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            ebatStokAdi: handleMultiSelect(e),
                          })
                        }
                      />
                    </Col>

                    {/* ebatTur */}
                    <Col md={3}>
                      <label className="form-label">Tür</label>
                      <Select
                        isMulti
                        options={
                          initialFilters?.ebat?.TÜR?.map((v) => ({
                            label: v,
                            value: v,
                          })) ?? []
                        }
                        value={filters.ebatTur.map((v) => ({
                          label: v,
                          value: v,
                        }))}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            ebatTur: handleMultiSelect(e),
                          })
                        }
                      />
                    </Col>

                    {/* ebatKalinlik */}
                    <Col md={3}>
                      <label className="form-label">Kalınlık</label>
                      <Select
                        isMulti
                        options={
                          initialFilters?.ebat?.KALINLIKmm?.map((v) => ({
                            label: v,
                            value: v,
                          })) ?? []
                        }
                        value={filters.ebatKalinlik.map((v) => ({
                          label: v,
                          value: v,
                        }))}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            ebatKalinlik: handleMultiSelect(e),
                          })
                        }
                      />
                    </Col>
                  </Row>

                  {/* FİLTRELE BUTONU */}
                  <Row className="mb-3">
                    <Col md={3} className="d-flex align-items-end">
                      <Button
                        className="w-100"
                        onClick={async () => {
                          const body = {
                            fileKey: data.fileKey,
                            ebatCins: filters.ebatCins,
                            ebatStokAdi: filters.ebatStokAdi,
                            ebatTur: filters.ebatTur,
                            ebatKalinlik: filters.ebatKalinlik,
                          };

                          const res = await customerApi.post(
                            "/sevkRapor",
                            body,
                            {
                              headers: {
                                Authorization: `Bearer ${sessionStorage.getItem(
                                  "token"
                                )}`,
                              },
                            }
                          );

                          const yeni = res.data.analizler.ebatGruplamaSevkKg;

                          setData((prev) => ({
                            ...prev,
                            analizler: {
                              ...prev.analizler,
                              ebatGruplamaSevkKg: yeni,
                            },
                          }));
                        }}
                      >
                        Filtrele
                      </Button>
                    </Col>
                  </Row>

                  {/* ======================================================
        EBAT TABLOSU
    ======================================================= */}
                  {(() => {
                    const analiz = data.analizler.ebatGruplamaSevkKg;
                    const yilObj = analiz.byYear?.[activeYear] ?? {};
                    const ebatObj =
                      yilObj.EBAT ?? analiz.general_total?.EBAT ?? {};

                    const rows = Object.entries(ebatObj)
                      .map(([ebat, obj]) => ({
                        ebat,
                        kg: obj.toplam,
                        pct: obj.yuzde,
                      }))
                      .sort((a, b) => (a.ebat > b.ebat ? 1 : -1));

                    const toplam = analiz.general_total?.genel_toplam ?? 0;

                    return (
                      <Table bordered hover responsive className="mt-3">
                        <thead className="table-light">
                          <tr>
                            <th>EBAT</th>
                            <th>KG</th>
                            <th>%</th>
                          </tr>
                        </thead>

                        <tbody>
                          {rows.map((row, i) => (
                            <tr key={i}>
                              <td>{row.ebat}</td>
                              <td>{fmt(row.kg)}</td>
                              <td>{row.pct.toFixed(2).replace(".", ",")} %</td>
                            </tr>
                          ))}

                          <tr
                            style={{
                              background: "#fffce6",
                              fontWeight: "bold",
                              borderTop: "3px solid #000",
                            }}
                          >
                            <td>Genel Toplam</td>
                            <td>{fmt(toplam)}</td>
                            <td>100 %</td>
                          </tr>
                        </tbody>
                      </Table>
                    );
                  })()}
                </Card>
              </Accordion.Body>
            </Accordion.Item>
          )}

          {/* ======================================================
    CARI ÜNVAN BAZINDA SEVK TONAJI --- FİLTRELER
        ====================================================== */}
          {data?.analizler?.cariSevkTonaj && (
            <Accordion.Item eventKey="cari">
              <Accordion.Header>
                Cari Ünvan Bazında Sevk Tonajı
              </Accordion.Header>
              <Accordion.Body>
                <Card className="p-3 mb-4">
                  <h5>Cari Ünvan Bazında Sevk Tonajı</h5>

                  <Row className="mb-3">
                    {/* cariCins */}
                    <Col md={3}>
                      <label className="form-label">Cins</label>
                      <Select
                        isMulti
                        options={
                          initialFilters?.cari?.Cins?.map((v) => ({
                            label: v,
                            value: v,
                          })) ?? []
                        }
                        value={filters.cariCins.map((v) => ({
                          label: v,
                          value: v,
                        }))}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            cariCins: handleMultiSelect(e),
                          })
                        }
                      />
                    </Col>

                    {/* cariStokAdi */}
                    <Col md={3}>
                      <label className="form-label">Stok Adı</label>
                      <Select
                        isMulti
                        options={
                          initialFilters?.cari?.["Stok Adı"]?.map((v) => ({
                            label: v,
                            value: v,
                          })) ?? []
                        }
                        value={filters.cariStokAdi.map((v) => ({
                          label: v,
                          value: v,
                        }))}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            cariStokAdi: handleMultiSelect(e),
                          })
                        }
                      />
                    </Col>

                    {/* cariTur */}
                    <Col md={3}>
                      <label className="form-label">Tür</label>
                      <Select
                        isMulti
                        options={
                          initialFilters?.cari?.TÜR?.map((v) => ({
                            label: v,
                            value: v,
                          })) ?? []
                        }
                        value={filters.cariTur.map((v) => ({
                          label: v,
                          value: v,
                        }))}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            cariTur: handleMultiSelect(e),
                          })
                        }
                      />
                    </Col>
                  </Row>

                  {/* FİLTRELE BUTONU */}
                  <Row className="mb-3">
                    <Col md={3} className="d-flex align-items-end">
                      <Button
                        className="w-100"
                        onClick={async () => {
                          const body = {
                            fileKey: data.fileKey,
                            cariCins: filters.cariCins,
                            cariStokAdi: filters.cariStokAdi,
                            cariTur: filters.cariTur,
                          };

                          const res = await customerApi.post(
                            "/sevkRapor",
                            body,
                            {
                              headers: {
                                Authorization: `Bearer ${sessionStorage.getItem(
                                  "token"
                                )}`,
                              },
                            }
                          );

                          const yeni = res.data.analizler.cariSevkTonaj;

                          setData((prev) => ({
                            ...prev,
                            analizler: {
                              ...prev.analizler,
                              cariSevkTonaj: yeni,
                            },
                          }));
                        }}
                      >
                        Filtrele
                      </Button>
                    </Col>
                  </Row>

                  {/* TABLO */}
                  {(() => {
                    const analiz = data.analizler.cariSevkTonaj;

                    const yilObj = analiz.byYear?.[activeYear] ?? {};
                    const detay =
                      yilObj.cari_unvani ??
                      analiz.general_total?.cari_unvani ??
                      {};

                    const toplam =
                      yilObj.genel_toplam ??
                      analiz.general_total?.genel_toplam ??
                      0;

                    const rows = Object.entries(detay)
                      .map(([cari, obj]) => ({
                        cari,
                        kg: obj.toplam,
                        pct: obj.yuzde,
                      }))
                      .sort((a, b) => b.kg - a.kg);

                    return (
                      <Table bordered hover responsive className="mt-3">
                        <thead className="table-light">
                          <tr>
                            <th>Cari Ünvanı</th>
                            <th>{activeYear} (Kg)</th>
                            <th>{activeYear} (%)</th>
                            <th>Toplam (Kg)</th>
                            <th>Toplam (%)</th>
                          </tr>
                        </thead>

                        <tbody>
                          {rows.map((row, i) => (
                            <tr key={i}>
                              <td>{row.cari}</td>
                              <td>{fmt(row.kg)}</td>
                              <td>{row.pct.toFixed(2).replace(".", ",")} %</td>
                              <td>{fmt(row.kg)}</td>
                              <td>{row.pct.toFixed(2).replace(".", ",")} %</td>
                            </tr>
                          ))}

                          <tr
                            style={{
                              background: "#fffce6",
                              fontWeight: "bold",
                              borderTop: "3px solid #000",
                            }}
                          >
                            <td>Genel Toplam</td>
                            <td>{fmt(toplam)}</td>
                            <td>100 %</td>
                            <td>{fmt(toplam)}</td>
                            <td>100 %</td>
                          </tr>
                        </tbody>
                      </Table>
                    );
                  })()}
                </Card>
              </Accordion.Body>
            </Accordion.Item>
          )}

          {/* ======================================================
    CARI ÜNVAN BAZINDA SEVK TONAJI
====================================================== */}

          {data?.analizler?.musteriDurum && (
            <Accordion.Item eventKey="musteri">
              <Accordion.Header>Müşteri Durumları</Accordion.Header>

              <Accordion.Body>
                {/* === FİLTRE === */}
                <div className="d-flex gap-2 mb-3">
                  {["Tümü", "İç Ticaret", "Dış Ticaret"].map((x) => (
                    <Button
                      key={x}
                      size="sm"
                      variant={
                        ticaretFilter === x ? "primary" : "outline-primary"
                      }
                      onClick={() => setTicaretFilter(x)}
                    >
                      {x}
                    </Button>
                  ))}
                </div>
                {/* === DURUM FİLTRESİ === */}
                <div className="d-flex gap-2 mb-3 flex-wrap">
                  {[
                    "Tümü",
                    "Yeni Müşteri",
                    "Devam Eden Müşteri",
                    "Kaybedilen Müşteri",
                  ].map((x) => (
                    <Button
                      key={x}
                      size="sm"
                      variant={
                        durumFilter === x ? "success" : "outline-success"
                      }
                      onClick={() => setDurumFilter(x)}
                    >
                      {x}
                    </Button>
                  ))}
                </div>

                {/* PDF BUTONU */}
                <div className="text-end mb-3">
                  <Button variant="secondary" onClick={handleDownloadExcel}>
                    PDF İndir
                  </Button>
                </div>

                <Card className="p-3 mb-4" ref={musteriRef}>
                  <h5>Müşteri Durumları</h5>

                  {/* === TABLO (FİLTRELİ) === */}
                  <div id="pdf-table-area">
                    <MusteriDurumTable
                      analiz={data.analizler.musteriDurum}
                      ticaretFilter={ticaretFilter}
                      durumFilter={durumFilter}
                    />
                  </div>

                  {/* === GRAFİK (FİLTRELİ) === */}
                  <div id="pdf-chart-area" style={{ marginTop: 40 }}>
                    {(() => {
                      const rowsAll = data.analizler.musteriDurum?.tablo || [];

                      // === TİCARET FİLTRESİ ===
                      const rows = rowsAll.filter((r) => {
                        const ticaretOK =
                          ticaretFilter === "Tümü" ||
                          ticaretTipi(r["Cari Ünvanı"]) === ticaretFilter;

                        const durumOK =
                          durumFilter === "Tümü" || r.durum === durumFilter;

                        return ticaretOK && durumOK;
                      });

                      // === ASIL MANTIK: DURUMA GÖRE SAY ===
                      const grafikOzet = {
                        "Yeni Müşteri": rows.filter(
                          (r) => r.durum === "Yeni Müşteri"
                        ).length,
                        "Devam Eden Müşteri": rows.filter(
                          (r) => r.durum === "Devam Eden Müşteri"
                        ).length,
                        "Kaybedilen Müşteri": rows.filter(
                          (r) => r.durum === "Kaybedilen Müşteri"
                        ).length,
                      };

                      const labels = Object.keys(grafikOzet);
                      const values = Object.values(grafikOzet);
                      const total = values.reduce((a, b) => a + b, 0);

                      const chartData = {
                        labels,
                        datasets: [
                          {
                            data: values,
                            backgroundColor: [
                              "#4CAF50", // Yeni
                              "#2196F3", // Devam Eden
                              "#F44336", // Kaybedilen
                            ],
                            borderColor: "#fff",
                            borderWidth: 1,
                          },
                        ],
                      };

                      return (
                        <>
                          {/* === DONUT CHART === */}
                          <div
                            style={{
                              width: 380,
                              height: 380,
                              margin: "40px auto",
                            }}
                          >
                            <Pie
                              data={chartData}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                cutout: "55%",
                                plugins: {
                                  legend: {
                                    position: "bottom",
                                    labels: {
                                      usePointStyle: true,
                                      padding: 20,
                                    },
                                  },
                                  tooltip: {
                                    callbacks: {
                                      label: (ctx) => {
                                        const v = ctx.raw;
                                        const pct = total
                                          ? ((v / total) * 100).toFixed(1)
                                          : "0.0";
                                        return ` ${v} müşteri (${pct}%)`;
                                      },
                                    },
                                  },
                                },
                              }}
                            />
                          </div>

                          {/* === ALT ÖZET KARTLAR === */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              gap: 20,
                              flexWrap: "wrap",
                            }}
                          >
                            {labels.map((label, i) => {
                              const v = values[i];
                              const pct = total
                                ? ((v / total) * 100).toFixed(1)
                                : "0.0";

                              return (
                                <div
                                  key={label}
                                  style={{
                                    width: 170,
                                    padding: 14,
                                    border: "1px solid #ddd",
                                    borderRadius: 10,
                                    textAlign: "center",
                                    background: "#fff",
                                  }}
                                >
                                  <b>{label}</b>
                                  <div
                                    style={{ fontSize: 22, fontWeight: 700 }}
                                  >
                                    {v}
                                  </div>
                                  <div style={{ fontSize: 14 }}>{pct} %</div>
                                </div>
                              );
                            })}
                          </div>
                        </>
                      );
                    })()}
                  </div>
                </Card>
              </Accordion.Body>
            </Accordion.Item>
          )}
        </Accordion>
      </div>
    </Layout>
  );
}
